/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import LoginForm from './LoginForm';
import ResetForm from './ResetForm';
import { useNavigate } from 'react-router-dom';
import Background from '../../assets/Images/png/bg.svg';
import SuccessForm from './SuccessForm';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { fadeIn } from 'react-animations';
import styled, { keyframes } from 'styled-components';
import FootersLayout from '../../components/layout/footer';
import IconLogo from '../../assets/Images/icons/icon-logo';
import UserService from '../../services/UserService';

const fadeInAnimation = keyframes`${fadeIn}`;

const FadeInDiv = styled.div`
    animation: 1s ${fadeInAnimation};
`;

const Login = ({ history }) => {
    const [currentPageAction, setCurrentPageAction] = useState({
        name: 'LOGIN',
        mail: '',
        text: '',
    });

    const { i18n } = useTranslation();

    let navigate = useNavigate();
    const isLogin = UserService.isLoggedIn();
    useEffect(() => {
        if (isLogin) {
            return navigate('/');
        }
    }, [isLogin]);

    return (
        <FadeInDiv
            className="h-screen w-full bg-cover bg-fixed bg-no-repeat bg-right relative"
            style={{
                backgroundImage: `url(${Background})`,
            }}
        >
            <div className="absolute top-8 right-10 text-sm z-30">
                <button
                    type="button"
                    className={classNames('cursor-pointer mx-2', {
                        'p-0.5 px-1 rounded-md text-white bg-purple':
                            i18n.language === 'th',
                    })}
                    onClick={() => i18n.changeLanguage('th')}
                >
                    TH
                </button>
                |
                <button
                    type="button"
                    className={classNames('cursor-pointer  mx-2 ', {
                        'p-0.5 px-1 rounded-md text-white bg-purple':
                            i18n.language === 'en',
                    })}
                    onClick={() => i18n.changeLanguage('en')}
                >
                    EN
                </button>
            </div>

            <div className="flex flex-col justify-center items-center w-full h-screen ">
                <div
                    className={classNames(
                        'w-[600px] h-[445px] m-auto rounded-[30px] pb-24 px-12 bg-white z-30 relative',
                        { 'h-[545px]': currentPageAction?.name !== 'LOGIN' }
                    )}
                    style={{
                        boxShadow: '0px 25px 42px rgba(123, 103, 251, 0.2)',
                    }}
                >
                    <div
                        hidden={currentPageAction?.name !== 'LOGIN'}
                        className="-mt-40"
                        style={{ color: '#A8A8AF', textAlign: 'center' }}
                    >
                        <IconLogo />
                    </div>
                    {(() => {
                        if (currentPageAction.name === 'LOGIN') {
                            return (
                                <LoginForm
                                    setCurrentPageAction={setCurrentPageAction}
                                    history={history}
                                />
                            );
                        } else if (currentPageAction.name === 'SUCCESS') {
                            return (
                                <SuccessForm
                                    currentPageAction={currentPageAction}
                                    setCurrentPageAction={setCurrentPageAction}
                                />
                            );
                        } else {
                            return (
                                <ResetForm
                                    currentPageAction={currentPageAction}
                                    setCurrentPageAction={setCurrentPageAction}
                                />
                            );
                        }
                    })()}
                </div>
                <div
                    className={classNames(
                        'absolute bg-[#F1F3FF] w-[600px] h-[445px] rounded-[30px] inset-auto -rotate-12 z-0',
                        { 'h-[545px]': currentPageAction?.name !== 'LOGIN' }
                    )}
                />
                <div
                    className={classNames(
                        'absolute bg-purple w-[600px] h-[445px] rounded-[30px] inset-auto rotate-12 z-10',
                        { 'h-[545px]': currentPageAction?.name !== 'LOGIN' }
                    )}
                />
            </div>
            <FootersLayout />
        </FadeInDiv>
    );
};

export default Login;
